import { Suspense } from "react"

import { ConfigProvider, ThemeConfig } from "antd"
import { GlobalModals } from "features/common/ui/GlobalModals"
import { UserInitializer } from "features/user/ui/UserInitializer"
import { Outlet } from "react-router-dom"
import { GlobalStyles } from "shared/styles/globalStyles"
import '@ant-design/v5-patch-for-react-19'
import { MetaTags } from 'components/MetaTags'
import { ThemeProvider } from 'shared/components/ThemeProvider'
import { useAppTheme } from 'shared/hooks/useAppTheme'

import { useGlobalDropzone } from './features/dropzone/useGlobalDropzone'

const AppThemeConfig: React.FC = () => {
  const theme = useAppTheme()
  
  const themeConfig: ThemeConfig = {
    token: {
      colorPrimary: theme.colors.primary,
      colorPrimaryBg: theme.colors.colorPrimaryBg,
      colorPrimaryBgHover: theme.colors.colorPrimaryBgHover,
      colorPrimaryBorder: theme.colors.colorPrimaryBorder,
      colorPrimaryBorderHover: theme.colors.colorPrimaryBorderHover,
      colorPrimaryHover: theme.colors.colorPrimaryHover,
      colorPrimaryActive: theme.colors.colorPrimaryActive,
      colorPrimaryTextHover: theme.colors.colorPrimaryTextHover,
      colorPrimaryText: theme.colors.colorPrimaryText,
      colorPrimaryTextActive: theme.colors.colorPrimaryTextActive,
    },
    components: {
      Alert: {
        colorInfoBg: theme.colors.accent || '#F9F0FF',
        colorInfoBorder: theme.colors.accent || '#E6CCFF',
        colorInfo: theme.colors.primary,
      },
    },
  }

  return (
    <ConfigProvider theme={themeConfig}>
      <ThemeProvider>
        <GlobalStyles />

        <UserInitializer />

        <GlobalModals />

        <MetaTags />

        <Outlet />
      </ThemeProvider>
    </ConfigProvider>
  )
}

export default function Layout() {
  const { getRootProps } = useGlobalDropzone()

  return (
    <Suspense fallback={''}
      {...getRootProps()}
    >
      <AppThemeConfig />
    </Suspense>
  )
}
